var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18316 1.97514V0.0911609H0V10.9088H1.60817V1.97514H5.18316Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.9088L9.49192 0.0911609H8.23084L5.23432 10.9088H6.91191L7.4094 8.99448H10.3365L10.8224 10.9088H12.5ZM9.90842 7.21685H7.86061L8.90187 3.28177L9.90842 7.21685Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.77901C19 6.59392 18.5372 5.74309 17.8083 5.31768C18.4678 4.86188 18.8843 4.04144 18.8843 2.99309C18.8843 1.16989 17.6695 0 16.1655 0C15.1011 0 14.1524 0.349447 13.3656 1.26105L14.3606 2.59807C14.8465 2.03591 15.4366 1.85359 16.096 1.85359C16.7324 1.85359 17.2761 2.30939 17.2761 3.14503C17.2761 4.01105 16.8596 4.51243 16.1539 4.51243H15.1126V6.24448H16.1423C16.8828 6.24448 17.3918 6.79144 17.3918 7.73343C17.3918 8.59945 16.7902 9.11602 16.0845 9.11602C15.344 9.11602 14.6614 8.85774 14.1061 8.20442L13.0764 9.57182C13.9788 10.6961 14.9275 11 16.1423 11C17.7505 11 19 9.73895 19 7.77901Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.445bbd0ba110c50517617ebc445895e7.svg";
export { ForwardRef as ReactComponent };